const form = document.getElementById("mailchimp-form");
if (form) {
	const input = document.getElementById("mailchimp-email");
	const button = document.getElementById("mailchimp-button");
	const inputs = document.querySelector("#mailchimp-form .grouped-inputs");
	const modal_body = document.querySelector("#mailchimp-form .d-grid");
	form.addEventListener("submit", function (evt) {
		evt.preventDefault();
		const nonce = jQuery(form).attr("data-nonce");
		const email = jQuery(input).val();
		const prev_alerts = document.querySelectorAll("#mailchimp-form .alert");
		prev_alerts.forEach(function (an_alert) {
			if (an_alert.parentNode !== null) {
				an_alert.parentNode.removeChild(an_alert);
			}
		});
		jQuery(input).prop("disabled", true);
		jQuery(button).prop("disabled", true);
		jQuery.ajax({
			type: "post",
			dataType: "json",
			url: WP_AJAX,
			data: {action: "mailchimp_subscribe", email: email, nonce: nonce},
			success: function (response) {
				const alert = document.createElement("div");
				alert.classList.add("alert");
				alert.classList.add(
					response.error ? "alert-danger" : "alert-primary"
				);
				alert.innerHTML = response.msg;
				modal_body.insertBefore(alert, modal_body.firstChild);
				if (!response.error) {
					if (inputs.parentNode !== null) {
						inputs.parentNode.removeChild(inputs);
					}
					Cookies.set("popup", "1", {expires: 365, path: "/"});
				} else {
					jQuery(input).prop("disabled", false);
					jQuery(button).prop("disabled", false);
				}
			},
		});
	});
}
